import type { SLODefinitions } from "./types";

export const SLO_DEFINITIONS: SLODefinitions = {
  API_ROUTE: {
    name: "API Route Performance",
    description: "Overall API route response time and error rate",
    targets: {
      p50: 200,
      p95: 500,
      p99: 1000,
      errorRate: 0.01,
      payloadSize: 5 * 1024 * 1024,
    },
    window: 5 * 60 * 1000,
  },
  DATABASE_QUERY: {
    name: "Database Query Performance",
    description: "Supabase query latency and error rate",
    targets: {
      p50: 100,
      p95: 300,
      p99: 500,
      errorRate: 0.005,
    },
    window: 5 * 60 * 1000,
  },
  CACHE_OPERATION: {
    name: "Cache Operation Performance",
    description: "Redis cache hit/miss and operation latency",
    targets: {
      p50: 10,
      p95: 50,
      p99: 100,
      errorRate: 0.01,
    },
    window: 5 * 60 * 1000,
  },
  DATA_FETCH: {
    name: "Data Fetch Performance",
    description: "Client-side data fetching latency",
    targets: {
      p50: 300,
      p95: 800,
      p99: 1500,
      errorRate: 0.02,
    },
    window: 5 * 60 * 1000,
  },
  EDGE_FUNCTION: {
    name: "Edge Function Performance",
    description: "Supabase Edge Function execution time",
    targets: {
      p50: 500,
      p95: 2000,
      p99: 5000,
      errorRate: 0.01,
    },
    window: 5 * 60 * 1000,
  },
};
